import styled from 'styled-components';

export const PointsPopupContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const PointsMap = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PointsProgressBar = styled.div`
  position: absolute;
  top: 1.625rem;
  left: 0.25rem;
  right: 0.25rem;
`;

export const PointsMapNote = styled.div`
  position: absolute;
  width: 50%;
  bottom: 1rem;
  left: 1rem;
  font-family: "NeueMachina";
  font-size: 1.25rem;
`;

export const PointsHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-family: "BebasNeue";
  text-transform: uppercase;
  white-space: nowrap;
`;

export const PointsHeaderCounter = styled.div`
  flex: 1;
  height: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const PointsHeaderCounterContent = styled.div`
  background: ${({ theme }) => theme.lightBlue};
  display: flex;
  flex-direction: row;
`;

export const PointsHeaderCounterImage = styled.img`
  height: 100%;
  aspect-ratio: 1 / 1;
  padding: 1rem;
`
export const PointsHeaderCounterInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`;

export const PointsHeaderCounterInfoSecondary = styled.div`
  padding-top: 0.5rem;
  font-size: 1.5rem;
  font-weight: 300;
`;
export const BoostLine = styled.div`
  .highlight {
    font-weight: 700;
  }

  .thin {
    font-weight: 300;
  }
`;

export const PointsAvatarsHolder = styled.div`
  padding: 0.5rem;
  padding-top: 4rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  width: 100%;
  overflow-x: auto;
`;

export const PointsHeaderCounterInfoMain = styled.div`
  font-size: 3rem;
  font-weight: 700;
`;

export const PointsHeaderTitle = styled.div`
  position: relative;
  font-size: 8rem;
  font-weight: 600;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-right: 4rem;
  .highlight {
    color: ${({ theme }) => theme.pointsGreen};
  }
`;

export const CloseButtonSection = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`;

export const PointsMapContainer = styled.div`
  width: 25%;
  height: 100%;
  position: relative;
  background: ${({ theme }) => theme.background};
  max-width: 22.5rem;
  border-left: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  display: flex;
  flex-direction: column;
`;

export const PointsStatsContainer = styled.div`
  flex: 1;
  overflow: hidden;
  height: 100%;
`;

export const InventoryAndStats = styled.div`
  width: 100%;
  padding: 1rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const PointsInventoryHolder = styled.div`
  flex: 1;
  overflow: hidden;
  width: 100%;
  background: ${({ theme }) => theme.lightBlue};
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.selectionBlue};
`;

export const StyledPointsInventory = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const PointsInventoryContent = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.background};
`;

export const PointsInventoryTabHeader = styled.div`
  width: 100%;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
  background: ${({ theme }) => theme.buttonDark};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  gap: 0.5rem;
`;

export const PointsInventoryTab = styled.div`
  width: 29%;
  border: solid ${({ $selected }) => $selected ? '2px': '1px'} ${({ theme, $selected }) => $selected ? theme.selectionBlue : 'black'};
  border-bottom: 0;
  background: ${({ theme, $selected }) => $selected ? theme.background : theme.background + '88'};
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  transition: linear .2s;

  &:hover {
    border: solid ${({ $selected }) => $selected ? '2px': '1px'} ${({ theme, $selected }) => $selected ? theme.selectionBlue : 'white'};
    border-bottom: 0;
  }
`;

export const PointsInventoryIcon = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const PointsInventoryPanel = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  background: ${({ theme }) => theme.background};
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.25rem;
  padding: 1rem;
  padding-bottom: 0;
  width: 100%;
`;

export const PointsInventoryControls = styled.div`
  width: 100%;
  padding: 1rem;
  background: ${({ theme }) => theme.background};
`;

export const PointsInventoryItem = styled.div`
  aspect-ratio: 1 / 1;
  position: relative;
`;

export const PointsInventoryItemImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
`;

export const StyledPointsStats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  font-family: "BebasNeue";
  text-transform: uppercase;
  font-size: 1.5rem;
  color: white;
  font-weight: 300;
  gap: 1rem;
  .green {
    color: ${({ theme }) => theme.pointsGreen};
  }

  .blue {
    color: ${({ theme }) => theme.selectionBlue};
  }

  .bold {
    font-weight: 700;
  }
`;

export const StyledPointsStatNames = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: end;
  gap: 0.5rem;
  opacity: 0.8;
`;

export const StyledPointsStatValues = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 0.5rem;

  img {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    width: 1rem;
    height: 1rem;
  }
`;

export const PointsShareNote = styled.div`
  font-family: "NeueMachina";
  max-width: 50%;
  color: white;
  font-weight: 700;
  font-size: 1.5rem;
`;

export const StatsContainer = styled.div`
  width: 100%;
  display: grid;
  gap: 1rem;
  padding: 1rem;
  grid-template-columns: repeat(3, 1fr);
`;

export const StyledStatWidget = styled.div`
  background: ${({ theme }) => theme.menuTitle};
  display: flex;
  padding: 1rem 1rem;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  justify-content: ${({ $align }) => $align || 'center'};

  @media (max-width: 1380px) {
    padding: 0.75rem 0.75rem;
    gap: 1.5rem;
  }

  @media (max-width: 1080px) {
    padding: 0.5rem 0.5rem;
    gap: 1rem;
  }
`;

export const StatWidgetImage = styled.img`
  width: 4rem;
  height: 4rem;
  min-width: 4rem;
  max-width: 4rem;
  min-height: 4rem;
  max-height: 4rem;

  @media (max-width: 1380px) {
    width: 3rem;
    height: 3rem;
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
  }

  @media (max-width: 1080px) {
    width: 2.25rem;
    height: 2.25rem;
    min-width: 2.25rem;
    max-width: 2.25rem;
    min-height: 2.25rem;
    max-height: 2.25rem;
  }
`;

export const StatWidgetFullLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
`;

export const StatWidgetReducedLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 2rem;

  @media (max-width: 1380px) {
    gap: 1.5rem;
  }

  @media (max-width: 1080px) {
    gap: 1rem;
  }
`;

export const StatWidgetValue = styled.div`
  font-family: "BebasNeue";
  font-weight: 700;
  font-size: 4.5rem;
  padding-top: 5%;
  text-transform: uppercase;
  color: ${({ $color }) => $color || 'white'};

  @media (max-width: 1380px) {
    font-size: 3.75rem;
  }
  @media (max-width: 1080px) {
    font-size: 2.875rem;
  }
`;

export const StatWidgetFullTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 0.5rem;
`;

export const StatWidgetMainTitle = styled.div`
  font-family: "BebasNeue";
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1.5rem;
  color: white;

  @media (max-width: 1380px) {
    font-size: 1.25rem;
  }

  @media (max-width: 1080px) {
    font-size: 1rem;
  }
`;

export const StatWidgetSecondaryTitle = styled.div`
  font-family: "BebasNeue";
  font-weight: 400;
  text-transform: uppercase;
  font-size: 1.5rem;
  color: ${({ $color }) => $color || 'white'};

  @media (max-width: 1380px) {
    font-size: 1.25rem;
  }

  @media (max-width: 1080px) {
    font-size: 1rem;
  }
`;

export const StatWidgetTitleValue = styled.div`
  font-family: "BebasNeue";
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2.25rem;
  color: white;

  @media (max-width: 1380px) {
    font-size: 1.875rem;
  }

  @media (max-width: 1080px) {
    font-size: 1.25rem;
  }
`;

export const StatWidgetReducedTitle = styled.div`
  font-family: "BebasNeue";
  font-weight: 400;
  text-transform: uppercase;
  font-size: 2.25rem;
  margin-top: -5%;
  color: ${({ $color }) => $color || 'white'};

  @media (max-width: 1380px) {
    font-size: 1.875rem;
  }

  @media (max-width: 1080px) {
    font-size: 1.25rem;
  }
`;
